import configFile from './config.json';

const config = {
  get: key => {
    return configFile.hasOwnProperty(key) ? configFile[key] : undefined;
  }
};

export default config;
